<template>
    <z-accordion>
        <z-accordion-item v-for="(committee, id) in committeesData" :key="id" :id="committee.code">
            <template v-slot:header>
                <span>{{ committee.name }}</span>
            </template>
            <template v-slot:body>
                <vue-raw
                    v-if="committee.previewText"
                    v-html="committee.previewText"
                    class="html-content u-bottom-margin--m"
                ></vue-raw>

                <div class="committee__container row">
                    <div
                        v-for="(member, code) in committee.members"
                        :key="code"
                        class="col-default-5 col-tablet-12"
                    >
                        <z-contact-card
                            :photo="
                                (member.previewPicture && member.previewPicture.link) ||
                                    '/images/people/_.jpeg'
                            "
                            :title="member.name"
                            :subtitle="member.position.value"
                            :link="`/${$root.lang}/company/governance/board-of-directors/${member.code}/`"
                            class="u-bottom-margin--xs"
                        />
                    </div>
                </div>

                <div class="row u-top-margin--s">
                    <div class="col-default-12">
                        <z-filelist size="s" v-if="committee.files">
                            <z-filelist-item
                                :icon="`file/${committee.files.type}`"
                                :info="committee.files.size"
                            >
                                <z-link :href="committee.files.link" v-html="committee.files.name"></z-link>
                            </z-filelist-item>
                        </z-filelist>
                    </div>
                </div>
            </template>
        </z-accordion-item>
    </z-accordion>
</template>

<script>
export default {
    name: 'committees',
    data () {
        return {
            committeesData: []
        }
    },
    mounted () {
        this.committeesData = this.$root.app.components['committees']
    }
}
</script>

<style lang="scss" scoped>
.committee {
    &__container {
        justify-content: space-between;
    }
}
</style>
